module.exports = __webpack_public_path__ + "img/banner_judicial.ccd077db.jpg";